var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "message" }, on: { "after-leave": _vm.afterLeave } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
          ],
          staticClass: "base-message",
          class: _vm.className,
          attrs: { role: "alert", tabindex: "0" },
          on: { mouseenter: _vm.clearTimer, mouseleave: _vm.startTimer },
        },
        [
          _c(
            "div",
            {
              staticClass: "base-message-icon",
              attrs: { "aria-hidden": "true" },
            },
            [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.iconObj[_vm.type]) },
              }),
            ]
          ),
          _c("div", { staticClass: "base-message-content" }, [
            _vm._v(_vm._s(_vm.message)),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }